import { render, staticRenderFns } from "./RequestResourcesForProductsChart.vue?vue&type=template&id=62551594&"
import script from "./RequestResourcesForProductsChart.vue?vue&type=script&lang=js&"
export * from "./RequestResourcesForProductsChart.vue?vue&type=script&lang=js&"
import style0 from "./RequestResourcesForProductsChart.vue?vue&type=style&index=0&id=62551594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports